var _style, _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProfileComplete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profile-complete_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1161.1 1161.1"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 580.6,
    cy: 580.6,
    r: 565.6,
    fill: "#6cc5cd",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M475.6 812.1h-.2c-8.6-.1-16.9-3.6-23-9.7L259.8 606.3c-12.6-12.8-12.4-33.4.4-46 12.8-12.6 33.4-12.4 46 .4l169.7 172.8 379.3-375.2c12.8-12.6 33.3-12.5 46 .2 12.6 12.8 12.5 33.3-.2 46L498.5 802.7c-6.1 6.1-14.3 9.4-22.9 9.4z"
  })));
}

export default SvgProfileComplete;